import React, { FC, ReactNode } from "react";

export interface CheckboxProps {
  label?: any;
  subLabel?: string;
  className?: string;
  name: string;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  truncate?: boolean;
  title?: string;
}

const Checkbox: FC<CheckboxProps> = ({
  subLabel = "",
  label = "",
  name,
  className = "",
  defaultChecked,
  onChange,
  truncate = false,
  title = "",
}) => {
  return (
    <div className={`flex text-sm sm:text-base ${className}`}>
      <input
        id={name}
        name={name}
        type="checkbox"
        className="h-6 w-6 flex-shrink-0 text-primary-100 border-primary rounded border-secondary-100 bg-white focus:ring-0"
        checked={defaultChecked}
        onChange={(e) => onChange && onChange(e.target.checked)}
      />
      {label && (
        <label
          htmlFor={name}
          className="ml-3.5 flex flex-col flex-1 justify-center overflow-hidden"
          title={title || (typeof label === 'string' ? label : '')}
        >
          <div className={`text-text-color ${truncate ? 'max-w-full truncate' : ''}`}>
            {label}
          </div>
          {subLabel && (
            <p className="mt-1 text-text-color text-sm font-light">
              {subLabel}
            </p>
          )}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
